import { ChatBotTemplateAPI } from "./ChatBotTemplateAPI";
import {UploadFolderModalAPI} from "./UploadFolderModalAPI";
export const chatBotTemplateAPI = new ChatBotTemplateAPI();
export const uploadFolderModalAPI= new UploadFolderModalAPI();

